import _ from "lodash";

export default {
  methods: {
    hasFeedback(property) {
      return this.getFeedback(property) !== null;
    },
    getFeedback(property) {
      if (!this.getFeedbackObject) {
        return null;
      }

      // eslint-disable-next-line no-prototype-builtins
      if (this.getFeedbackObject.hasOwnProperty("errors") && this.getFeedbackObject.errors.hasOwnProperty(property)) {
        return this.getFeedbackObject.errors[property];
      }

      return null;
    },
    getFeedbackString(property) {
      if (this.hasFeedback(property)) {
        return this.getFeedback(property).join(", ");
      }

      return null;
    },
    deleteError(property) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.getFeedbackObject.hasOwnProperty("errors") && this.getFeedbackObject.errors.hasOwnProperty(property)) {
        delete this.getFeedbackObject.errors[property];
      }
    },
  },
  watch: {
    getFeedbackObject: {
      handler(newValue) {
        let { errors } = newValue;

        if (this.properties) {
          errors = _.filter(errors, (value, key) => this.properties.includes(key));
        }
        // eslint-disable-next-line no-prototype-builtins
        this.$emit("errorsCount", newValue.hasOwnProperty("errors") ? Object.keys(errors).length : 0);
      },
      deep: true,
    },
  },

};
